
<script>
export default {
  name: 'ScrollTop'
}
</script>

<script setup>
import { ref, computed, onMounted } from 'vue';

const isBtnShow = ref(false);
const isAbsolutePosition = ref(false);
const spNum = ref(0);

const header = ref({});
const footer = ref({});
const phoneFooter = ref({});
const phoneFooterHeight = ref(0);

const showStyle = computed({
  get() {
    // 非表示時も位置スタイルを残し、fade leave 中に位置だけ瞬間移動する段差を防ぐ
    const footerEl = footer.value;
    const footerHeight = (footerEl && footerEl.clientHeight) || 0;

    // PC: #footer1 表示中は最下部接近時も fixed のままにし、containing block 差による段差を回避
    if (footerHeight > 0) {
      return {
        position: 'fixed',
        bottom: (footerHeight + spNum.value) + 'px'
      };
    }

    // モバイル: #footer1 非表示
    if (isAbsolutePosition.value) {
      return {
        position: 'absolute',
        bottom: (footerHeight + spNum.value) + 'px'
      };
    }
    if (phoneFooterHeight.value > 0) {
      return {
        position: 'fixed',
        bottom: (phoneFooterHeight.value + 10) + 'px'
      };
    }
    // どちらのフッターも無い場合のフォールバック
    return {
      position: 'fixed',
      bottom: '0px'
    };
  }
});

const setVisibleEvent = () => isBtnShow.value = window.scrollY > header.value.clientHeight + 20;

const setPositionEvent = () => {
  const documentHeight = document.getElementsByTagName('html')[0].scrollHeight + 1;
  const scrollPosition = window.innerHeight + window.scrollY;

  spNum.value = window.innerWidth <= 821 ? 10 : 55;

  // 参照先が detached（破棄済み）な旧ノードの場合は取り直してから高さを読む
  if (!phoneFooter.value || !phoneFooter.value.isConnected) {
    phoneFooter.value = document.querySelector('.com_app_nav1');
  }
  phoneFooterHeight.value = phoneFooter.value ? phoneFooter.value.clientHeight : 0;

  if (!footer.value || !footer.value.isConnected) {
    footer.value = document.getElementById('footer1');
  }
  if (footer.value !== null) {
    isAbsolutePosition.value = documentHeight - scrollPosition <= footer.value.clientHeight;
  }
}

const clickPageTop = () => {
  window.scroll({
    top: 0,
    behavior: 'smooth'
  });
}

onMounted(() => {
  header.value = document.getElementById('com_app_header1');
  footer.value = document.getElementById('footer1');
  phoneFooter.value = document.querySelector('.com_app_nav1');

  if (header.value !== null) {
    window.addEventListener('scroll', setVisibleEvent);
    window.addEventListener('load', setVisibleEvent);
  }

  window.addEventListener('scroll', setPositionEvent);
  window.addEventListener('load', setPositionEvent);
})
</script>

<template>
<transition name="fade">
  <div id="com_pagetop1" :style=showStyle v-show="isBtnShow"><div><span @click="clickPageTop"></span></div></div>
</transition>
</template>

<style scoped>
.absolute {
  white-space: pre-wrap
}

#com_pagetop1 {
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
